import React from 'react';
import { AppBar } from 'react-admin';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import {ReactComponent as Logo} from '../logo.svg'
import { Link } from 'react-router-dom';

const styles = {
    title: {
        flex: 1,
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
    },
    spacer: {
        flex: 1,
    },
};

const CustomAppBar = ({ classes, ...props }) => (
    <AppBar {...props} >
        <Typography
            variant="inherit"
            color="inherit"
            className={classes.title}
            id="react-admin-title"
        />

        <Link to={{pathname: "/"}} ><Logo atl="substitute teachers logo"/></Link>

    </AppBar>
);

export default withStyles(styles)(CustomAppBar);
